import { IconArrowPath } from '../../components/icons';

/**
 * Unticks a whole list behind a native confirm, like `DeleteButton` — but it
 * is not a delete, so it neither looks like one nor shares its icon.
 */
export function ResetButton({
  confirm,
  onConfirm,
  label,
  disabled,
}: {
  /** The question, naming every list that will change. */
  confirm: string;
  onConfirm: () => void;
  label: string;
  disabled: boolean;
}) {
  return (
    <button
      type="button"
      className="btn-icon-ghost"
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={() => {
        if (window.confirm(confirm)) onConfirm();
      }}
    >
      <IconArrowPath />
    </button>
  );
}
